/**
 * What the app's main client does with an expired session or a plan limit.
 *
 * The refresh itself lives in one place now and is shared with every other client, so two of
 * them can never rotate the refresh token underneath each other. A failed refresh still ends
 * the session, because there is nothing left to continue with.
 */
import api from './api';
import store from '../../store/store.js';
import { refreshAccessToken } from '../refresh';
import { refreshAccount } from '@/http/requests/account';

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const original = error.config;
    const status = error.response && error.response.status;

    if (status === 402) {
      error.planLimit = error.response.data || {};
      refreshAccount();
      return Promise.reject(error);
    }

    if (status !== 401 || !original || original._retry) {
      return Promise.reject(error);
    }
    original._retry = true;

    return refreshAccessToken().then((token) => {
      if (!token) {
        // the session is genuinely over: clear it and send them to sign in, keeping any
        // checkout they had waiting
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userInfo');
        window.location.href = '/v2login';
        return Promise.reject(error);
      }
      store.commit('SET_BEARER', token);
      original.headers.Authorization = `Bearer ${token}`;
      return api(original);
    });
  }
);

export default api;
